(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wn-article"]) return;
  try {
    
  if (!customElements.get('wn-journal-article')) {
    customElements.define('wn-journal-article', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const body = this.querySelector('.wn-article__body');
        const contents = this.querySelector('.wn-article__contents');
        if (!body || !contents) return;
        const title = body.dataset.articleTitle.trim().toLowerCase();
        // Remove only exact duplicate titles and empty introduction labels in the opening.
        for (const element of [...body.children]) {
          if (/^H[1-6]$/.test(element.tagName)) break;
          if (element.tagName !== 'P') continue;
          const text = element.textContent.trim().toLowerCase();
          if (text === title || /^introduction\s*:?$/.test(text)) element.hidden = true;
        }
        body.querySelectorAll('table').forEach(table => {
          const wrapper = document.createElement('div');
          wrapper.className = 'wn-article__table';
          table.before(wrapper);
          wrapper.append(table);
        });
        const headings = [...body.querySelectorAll('h2')];
        if (headings.length < 2) return;
        const list = contents.querySelector('ol');
        headings.forEach((heading, index) => {
          if (!heading.id) heading.id = `${this.id}-heading-${index + 1}`;
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent;
          item.append(link);
          list.append(item);
        });
        contents.hidden = false;
        contents.open = window.matchMedia('(min-width: 760px)').matches;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
